import Vue from "vue";

Vue.filter("terminaleTypeName", function(value: number) {
  {
    switch (value) {
      case 1:
        return "NettoCheck";
      case 2:
        return "NettoCash";
      case 3:
        return "Bank";
      case 4:
        return "ATM";
      case 5:
        return "Shop ";
      case 6:
        return "MobilStore";
      case 7:
        return "PaymentSystem ";
      case 8:
        return "RunPayMini ";
      case 9:
        return "RunPayXL ";
      case 10:
        return "RunPayWeb ";
      default:
        return "Без имени";
    }
  }
});

/**
   * // <summary>
        /// Все хорошо
        /// </summary>
        Success = 0,
        /// <summary>
        /// Техническая проблема
        /// </summary>
        TechnicalProblem = 1,
        /// <summary>
        /// Нет связи
        /// </summary>
        NoConnection = 2,
        /// <summary>
        /// Требуется инкосация или сбор кеша
        /// </summary>
        CashCollection = 3,
        /// <summary>
        /// Установка новой точки
        /// </summary>
        Install = 4,
        /// <summary>
        /// Отрицательный доступный баланс 
        /// </summary>
        NegativeAvailableBalance = 5
   */



// WEBPACK FOOTER //
// ./scripts/filters/terminaleTypeName.ts